import {save} from "../operations/save";

export function saveCell(row, column){
	var style = this.getStyle(row, column);

	save(this, "data", {
		row: row,
		column: column,
		value: this.getCellValue(row, column),
		style: (style ? style.id : "")
	});
}